/*
  Reveal on scroll da banda premium de categoria (fade + subida sutil).
  Escopo: somente [data-cp-reveal] dentro de [data-cp]. Sem JS nada fica
  oculto (o estado pendente só é aplicado aqui); desligado com
  prefers-reduced-motion e no editor de temas.
*/
(() => {
  if (window.__suplCollectionPremium) return;
  window.__suplCollectionPremium = true;

  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  const init = () => {
    const targets = document.querySelectorAll('[data-cp] [data-cp-reveal]');
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('cp-reveal--in');
          observer.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    for (const el of targets) {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight) continue;
      el.classList.add('cp-reveal--pending');
      observer.observe(el);
    }
  };

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init, { once: true });
  }
})();
